export const ADD_COINS_BOUGHT_EVENT = 'ADD_COINS_BOUGHT_EVENT';

function coinsBoughtEventReducer (state = [], action) {
  switch (action.type) {
    case ADD_COINS_BOUGHT_EVENT:
      return [...state, action.payload];
    default:
      return state;
  }
}

export default coinsBoughtEventReducer;




// WEBPACK FOOTER //
// ./src/storage/CoinsBoughtEventReducer.js